var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#4055A6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.988 7.071c.125.189.133.566-.06.845c-.197.278-.728.458-1.157.043c-1.118-1.08-2.833-1.29-3.634-1.29A5.35 5.35 0 0 0 6.63 12c.043 2.211 1.538 5.331 5.507 5.331c1.114 0 2.983-.48 3.926-1.465c.162-.172.745-.065.951.192c.21.258.15.858-.086 1.06a7.54 7.54 0 0 1-4.795 1.74c-3.858 0-6.99-3.07-6.99-6.858c0-3.789 3.128-6.857 6.994-6.857c3.214 0 4.77 1.804 4.851 1.928"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.428 11.143a1.286 1.286 0 1 0 0-2.572a1.286 1.286 0 0 0 0 2.572"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.428 10.286a.429.429 0 1 0 0-.858a.429.429 0 0 0 0 .858"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCel);
export default __webpack_public_path__ + "static/media/cel.7bf4491b198b863229c6ddeb7aff1627.svg";
export { ForwardRef as ReactComponent };